import React from "react"
import SidePanelHeader from "components/Builder/components/SidePanelHeader"
import EditorSection from "components/Builder/components/EditorSection"
import TextField from "components/ReactHookForm/TextField"
import FontSelect from "components/Builder/components/FontSelect"
import HeadingSizeSelect from "components/Builder/components/HeadingSizeSelect"
import AlignmentSelect from "components/Builder/components/AlignmentSelect"
import PaddingInputs from "components/Builder/components/PaddingInputs"
import ColorSelect from "components/ReactHookForm/ColorSelect/ColorSelect"
import { Control } from "react-hook-form"

type Props = {
  control: Control
}

const HeadingFields = ({ control }: Props) => (
  <>
    <SidePanelHeader>Heading Block</SidePanelHeader>
    <EditorSection>
      <TextField name="text" control={control} variant="outline" />
    </EditorSection>
    <EditorSection>
      <FontSelect control={control} />
      <HeadingSizeSelect control={control} />
      <AlignmentSelect control={control} />
    </EditorSection>
    <EditorSection>
      <PaddingInputs control={control} />
    </EditorSection>
    <EditorSection>
      <ColorSelect label="Text Color" name="textColor" control={control} />
    </EditorSection>
    <EditorSection>
      <ColorSelect label="Block Color" name="blockColor" control={control} colorScheme="light" />
    </EditorSection>
  </>
)

export default HeadingFields
